import Vue from 'vue';
import { getGeolocation } from '@/library/utils/geolocation'

const plugin = {
    install(Vue, options){
        Vue.prototype.$geolocation = getGeolocation();
    }
}

Vue.use(plugin)

export default plugin;